/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = New
 *
 * 1 = Used
 *
 * 2 = NewAndUsed
 */
export enum NewOrUsedFilter {
  New = 0,
  Used = 1,
  NewAndUsed = 2,
}
